import React from 'react'
import AnimationLayout from '../components/AnimationLayout'

const NoMatch = () => {
    return (
        <AnimationLayout>
            <div className='grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6 md:gap-8 lg:gap-12 pb-6'>
                <div className='text-left py-2 py-md-0'>
                    <h3 className='py-2 py-md-0'>404 error</h3>
                    <h4>page not found</h4>
                </div>
                <div className='text-center'>
                    <p>teste</p>
                </div>
            </div>
        </AnimationLayout>
    )
}

export default NoMatch